const short = require('short-uuid');
const baseModel = require("../baseModel")
const UserInfo = require('../../appUtils/UserInfo');

/**
 * ツリー用のデータ取得モデルクラス
 */
class TreeItemModel extends baseModel {
  /**
   * テナント内のツリーリストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async list(sk, tenantId = null) {

    return await super.getList({beginsWith: `${sk}`}, tenantId)
  }

  /**
   * lsiStr1指定でリストを取得する
   * @param {*} lsiStr1 
   * @returns 
   */
  static async listLsiStr1(lsiStr1, tenantId = null) {
    return await super.getLsistr1List({ beginsWith: `${lsiStr1}` }, tenantId)
  }
  /**
   * ツリーを削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async delete(data) {
    await super.deleteData(data)
  }

  /**
   * ツリー管理レコードを追加する
   * @param {*} data
   */
  static async add(data){
    await super.addData(data)
  }

  /**
   * ツリー管理レコードを更新する
   * @param {*} data
   */
  static async update(data) {
    await super.updateData(data)
  }

  /**
   * ツリー管理レコードを取得する
   * @param {*} data
   */
  static async get(sk, tenantId = null){

    let treeData = await super.getSingleData({sk: sk}, tenantId);
    
    return treeData
   
  }

  /**
   * ツリー項目に階層レベルを追加します。
   * @param {*} treeItem 1つのツリー項目
   * @param {Number} depthLv 階層レベル(ルートは0)
   * @returns 階層レベルを追加した1つのツリー項目
   */
  static async getDepthLevel(treeItem, depthLv) {
    // 返却用に複製
    let result = Object.assign({}, treeItem);

    // console.log(treeItem)

    // 現在の階層レベルを追加
    result['depthLv'] = depthLv;

    // 階層レベルインクリメント
    depthLv++;

    // 子階層処理
    let children = result.children;
    if (!children || children.length == 0) {
      // 子階層なし
      // console.log(result)
      return result;
    } else {
      for (let i = 0; i < children.length; i++) {
        // 再帰
        result.children[i] = await this.getDepthLevel(children[i], depthLv)
      }

    }

    // console.log(result)
    return result;
  }
  /**
   * skの文字列を生成
   * @param {*}
   * @returns
   */
  static createSk(projectId, nodeId = null){
    if (nodeId) {
      return `tree#${projectId}#${nodeId}`
    } else {
      return `tree#${projectId}`
    }
  }
  
  /**
   * 新規登録用のテンプレート
   * @param {*} parentSk 親ノードのsk（ルートの場合は指定しない
   * @returns 
   */
  static async getNewData(projectId) {
    const id = short.generate()
    let newRowData = await super.getNewData()

    newRowData.sk = this.createSk(projectId, id)
    // TODO: treeItemに変更する
    newRowData.treeItem = {
      label: "",
      id: `${id}`,
      type: ""
    }
    return newRowData
   
  }
}

module.exports = TreeItemModel
